export default __webpack_public_path__ + "static/media/send.70b064f7.png";